module.exports = __webpack_public_path__ + "img/7-about.1d5bb544.jpg";